import React from 'react'

const TotalConTarjeta = (props) => {

      const interesesCuota = parseFloat(props.importeAPagar) * parseFloat(props.cuotaElegida.interes / 100);
      const totalReservaSinImpuesto = parseFloat(props.totalPaquete) - parseFloat(props.impuestoPais);
      const totalAPagar = parseFloat(props.importeAPagar) + interesesCuota;
      const nuevoTotaReservaConImpEInt = parseFloat(props.totalPaquete)  + interesesCuota;//- parseFloat(props.impuestoPais) + parseFloat(props.importeProporcionalRGPais)
      const saldo = nuevoTotaReservaConImpEInt - totalAPagar;

      return (
        <div className="aside">
                  <div className="heading" style={{minHeight: '0'}}>
                    <div className="title" style={{padding: '0.8rem'}}>
                      <h5>A Pagar con Tarjeta</h5>
                    </div>
                    <ul className="info form-row">
                      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Total sin impuestos e intereses</li>
                      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">$ {Math.ceil(totalReservaSinImpuesto)}</li>

                      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Intereses de la tarjeta</li>
                      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">$ { Math.ceil(interesesCuota) }</li>

                      {props.importeProporcionalRGPais > 0 && <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Impuesto Pais (proporcional)</li> }
                      {props.importeProporcionalRGPais > 0 && <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">$ {Math.ceil(props.importeProporcionalRGPais)}</li> }
                    </ul>

                    <ul style={{borderColor: 'transparent'}} className="info form-row">
                      <li style={{fontSize: '0.9rem'}} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Nuevo Total Reserva</li>
                      <li style={{fontSize: '0.9rem'}} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">$ {Math.ceil(nuevoTotaReservaConImpEInt)}</li>
                    </ul>

                    <ul  className="info form-row">
                      <li style={{fontSize: '0.9rem'}} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Total a Pagar</li>
                      <li style={{fontSize: '0.9rem'}} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">$ {totalAPagar.toFixed(2)}</li>

                      <li style={{fontSize: '0.9rem'}} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Saldo</li>
                      <li style={{fontSize: '0.9rem'}} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">$ {saldo.toFixed(2)}</li>
                    </ul>
                  </div>
                </div>
      );

}

export default TotalConTarjeta



// WEBPACK FOOTER //
// ./src/components/Global/TotalConTarjeta.js